module.exports = __webpack_public_path__ + "img/cover-tnw.666bfeeb.jpg";